// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonRegisteredTrademark_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s8IconSvg = html `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4ZM7 4C7 5.65685 5.65685 7 4 7C2.34315 7 1 5.65685 1 4C1 2.34315 2.34315 1 4 1C5.65685 1 7 2.34315 7 4ZM4.79639 5.7659H5.70215L5.04053 4.73074C5.00635 4.67703 4.9681 4.62251 4.92578 4.56717C4.88509 4.5102 4.84196 4.45731 4.79639 4.40848C4.75081 4.35965 4.70361 4.31733 4.65479 4.28152C4.60596 4.24409 4.5555 4.21723 4.50342 4.20096V4.19119C4.62223 4.15701 4.72965 4.10981 4.82568 4.04959C4.92334 3.98937 5.00635 3.91776 5.07471 3.83475C5.14307 3.75174 5.19596 3.65897 5.2334 3.55643C5.27083 3.45226 5.28955 3.33914 5.28955 3.21707C5.28955 2.58231 4.86475 2.26492 4.01514 2.26492H2.76514V5.7659H3.55371V4.42557H3.76611C3.81494 4.42557 3.8597 4.43615 3.90039 4.45731C3.94271 4.47684 3.98258 4.50613 4.02002 4.5452C4.05908 4.58263 4.09733 4.6282 4.13477 4.68192C4.1722 4.73563 4.21126 4.79666 4.25195 4.86502L4.79639 5.7659ZM3.55371 3.82986V2.85574H3.91016C4.27637 2.85574 4.45947 3.00874 4.45947 3.31473C4.45947 3.46121 4.40739 3.5841 4.30322 3.68338C4.20068 3.78104 4.06478 3.82986 3.89551 3.82986H3.55371Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonRegisteredTrademark is a generated icon component.
 */
let IconCommonRegisteredTrademark = IconCommonRegisteredTrademark_1 = class IconCommonRegisteredTrademark extends IconBaseElement {
    render() {
        return html `${IconCommonRegisteredTrademark_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonRegisteredTrademark.icons = new Map([
    ['s8', _s8IconSvg],
    ['s12', _s8IconSvg],
    ['s16', _s8IconSvg],
    ['s24', _s8IconSvg],
    ['s32', _s8IconSvg],
    ['s40', _s8IconSvg],
    ['s48', _s8IconSvg],
    ['s64', _s8IconSvg],
    ['s72', _s8IconSvg],
    ['s80', _s8IconSvg],
]);
IconCommonRegisteredTrademark = IconCommonRegisteredTrademark_1 = __decorate([
    customElement('zui-icon-common-registered-trademark')
], IconCommonRegisteredTrademark);
export { IconCommonRegisteredTrademark };
